t = require('app/scripts/views/internal/teacup-with-helpers')('power_ups_calendar_prefs')

module.exports = t.renderable ({ isEnabled, isGenerated, url, canChange }) ->
  t.p ->
    t.format 'sync-this-trello-boards-calendar-with-your-personal-calendar'

  if isEnabled
    t.hr()

    t.strong ->
      t.format 'icalendar-feed'

    t.div '.icalendar-url', ->
      t.input '.full.js-calendar-feed-url', {
        type: 'text',
        value:
          if isGenerated
            url
          else
            t.l 'generating'
      }
      t.a '.button.js-regen-calendar-url', { href: '#', class: t.classify('disabled': !isGenerated) }, ->
        t.span '.icon-lg.icon-refresh.dark-hover'

    t.div '.u-text-align-center', ->
      t.a '.js-select.js-calendar-pref-feed', { href: '#', class: t.classify('disabled': !canChange), name: 'disabled' }, ->
        t.span '.name', ->
          t.format 'disable-sync'
  else
    t.div '.u-text-align-center', ->
      t.a '.js-select.js-calendar-pref-feed', { href: '#', class: t.classify('disabled': !canChange), name: 'enabled' }, ->
        t.span '.name', ->
          t.format 'enable-sync'

